"use client";
import React, { useEffect, useState } from "react";
import orderService from "@/services/order-service";

// One animated candle for the whole page, however many people bought a candle or are 1/5-year Keepers;
// all their names are listed under it, one per line. Nothing is shown when there is nobody to list.
const PremiumCandles = ({ obituaryId, onOrderCandle, onLoaded }) => {
  const [names, setNames] = useState([]);

  useEffect(() => {
    if (!obituaryId) return;
    let cancelled = false;
    orderService
      .getPremiumCandleNames(obituaryId)
      .then((list) => {
        if (cancelled) return;
        setNames(list);
        // The page uses this to hide its "Dodaj spominsko svečko" link once a candle is shown.
        onLoaded?.(list.length > 0);
      })
      .catch(() => {
        if (cancelled) return;
        setNames([]);
        onLoaded?.(false);
      });
    return () => {
      cancelled = true;
    };
  }, [obituaryId]); // eslint-disable-line react-hooks/exhaustive-deps

  if (names.length === 0) return null;

  return (
    <section
      aria-label="Spominska svečka"
      className="mt-[68px] mb-[40px] flex w-full flex-col items-center self-center"
    >
      {/* 220x130, corners rounded 1px, no frame; 40px more space above the picture and below the section. */}
      <div>
        <video
          src="/spominska_svecka_premium.mp4"
          autoPlay
          loop
          muted
          playsInline
          aria-label="Animirana spominska svečka"
          className="h-[130px] w-[220px] rounded-[1px] object-cover"
        />
      </div>
      <ul className="mt-3 flex flex-col items-center text-center">
        {names.map((name) => (
          <li key={name} className="break-words text-[18px] leading-[26px] text-[#1E2125]">
            {name}
          </li>
        ))}
      </ul>
      {onOrderCandle && (
        <button
          type="button"
          onClick={onOrderCandle}
          className="mt-3 text-[14px] leading-[20px] text-[#6D778E] hover:underline cursor-pointer"
        >
          Prižgi virtualno svečko
        </button>
      )}
    </section>
  );
};

export default PremiumCandles;
